@for (payment of purchase.payments; track payment) {
    <div class="card mt-1">
        <div class="card-body">
            <h5 class="card-title main-blue">
                {{ "PurchaseDetails.paymentDetails" | translate }}
            </h5>
            <div class="card-text">
                @if (payment) {
                    <div class="row">
                        <div class="col-sm-2 bolded">
                            {{ "PurchaseDetails.paidAmount" | translate }}
                        </div>
                        <div class="col-sm-10">
                            {{ payment.amount | amount }}
                        </div>
                    </div>
                }
                @if (payment) {
                    <div class="row">
                        <div class="col-sm-2 bolded">
                            {{
                                "PurchaseDetails.paymentMethodType" | translate
                            }}
                        </div>
                        <div class="col-sm-10">
                            {{ translatePaymentMethod(payment.paymentMethod) }}
                        </div>
                    </div>
                }
                @if (payment.creditCardNumber || payment.giftCardNumber) {
                    <div class="row">
                        @if (isCCPayment(payment)) {
                            <div class="col-sm-2 bolded">
                                {{ "PurchaseDetails.creditCard" | translate }}
                            </div>
                        }
                        @if (isDCPayment(payment)) {
                            <div class="col-sm-2 bolded">
                                {{ "PurchaseDetails.debitCard" | translate }}
                            </div>
                        }
                        @if (isGiftCard(payment)) {
                            <div class="col-sm-2 bolded">
                                {{ "PurchaseDetails.giftCard" | translate }}
                            </div>
                        }
                        <div class="col-sm-10">
                            {{
                                payment.creditCardNumber ??
                                    payment.giftCardNumber
                            }}
                        </div>
                    </div>
                }
                @if (payment.creditCardHolder) {
                    <div class="row">
                        <div class="col-sm-2 bolded">
                            {{ "PurchaseDetails.cardHolder" | translate }}
                        </div>
                        <div class="col-sm-10">
                            {{ payment.creditCardHolder }}
                        </div>
                    </div>
                }
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.paymentStatus" | translate }}
                    </div>
                    @if (!payment.isOriginalPayment) {
                        <div
                            class="col-sm-10 bolded"
                            [ngClass]="{
                                'main-green': !isRefunded,
                                'main-red': isRefunded,
                            }"
                        >
                            {{ purchase.status }}
                            @if (purchase.isModification) {
                                <span class="main-red ml-1">{{
                                    "PurchaseDetails.partiallyRefunded"
                                        | translate
                                }}</span>
                            }
                        </div>
                    }
                    @if (payment.isOriginalPayment) {
                        <div class="col-sm-10 bolded main-green">
                            {{
                                "PurchaseDetails.originalPaymentStatus"
                                    | translate
                            }}
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
